
import React from 'react';
import { formatoDecimal } from '../../utilities/formatoNumeros';
import { updateEstadoTiposPublicaciones } from '../../api/axios';
import { toast } from '../../utilities/appToast';
import { toastEstadoCambio } from '../../utilities/toastEstado';

export default class TipoPublicacionesListItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      estado: props.estado
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.estado !== this.props.estado) {
      this.setState({ estado: this.props.estado });
    }
  }

  handleSwitchChange = async (e) => {
    e.stopPropagation();
    const { codigo, filtro, onEstadoActualizado, onBuscarConEstado, userId } = this.props;
    const nuevoEstado = this.state.estado === 0 ? 2 : 0;
    try {
      const response = await updateEstadoTiposPublicaciones({
        idUsuario: Number.parseInt(userId, 10) || 0,
        id: codigo,
        estado: nuevoEstado,
      });
      const mensaje = response?.data?.mensaje || 'Estado actualizado';
      this.setState({ estado: nuevoEstado }, () => {
        toastEstadoCambio(mensaje, nuevoEstado);
        if (filtro && typeof filtro.estado === 'number' && typeof onBuscarConEstado === 'function') {
          onBuscarConEstado(filtro.estado);
        } else if (typeof onEstadoActualizado === 'function') {
          onEstadoActualizado(codigo, nuevoEstado);
        }
      });
    } catch (err) {
      toast.warn('Error al actualizar el estado');
    }
  };


  render = () => {
    const { codigo, descripcion, comision, cantidadGrupoPlanes, cantidadPublicaciones, grupoPlanes } = this.props;
    const { estado } = this.state;
    const isActivo = estado === 0;
    const cardEstado = isActivo ? 'admin-list-card--vigente' : 'admin-list-card--inactivo';
    const descripcionGrupoPlanes = Array.isArray(grupoPlanes)
      ? grupoPlanes
        .map((g) => g?.descripcion ?? g?.Descripcion ?? "")
        .filter((txt) => txt && txt.trim().length > 0)
        .join(", ")
      : "";

    return (
      <div className={`admin-list-card p-3 ${cardEstado}`}>
        <div className="row g-2 g-md-3 align-items-center justify-content-between">
          <div className="col-auto" style={{ cursor: 'pointer' }} onClick={this.props.onEdit}>
            <span className="admin-id-badge">{codigo}</span>
          </div>
          <div className="col-12 col-md-4 col-lg-5 text-break">
            <div
              className="admin-list-card__title fw-semibold small mb-0"
              style={{ cursor: 'pointer' }}
              onClick={this.props.onEdit}
            >
              {descripcion}
            </div>
            {descripcionGrupoPlanes ? (
              <input
                type="text"
                readOnly
                value={descripcionGrupoPlanes}
                className="form-control-plaintext small p-0 mt-1"
                title="Seleccioná y copiá los grupos de planes"
                style={{ cursor: 'text' }}
                onClick={(e) => e.stopPropagation()}
                aria-label="Grupos de planes"
              />
            ) : null}
          </div>
          <div className="col-6 col-md-auto d-flex justify-content-md-end">
            <span className="admin-metric-pill">
              <i className="fas fa-box-open" aria-hidden="true" />
              {cantidadPublicaciones} <span className="fw-normal text-body-secondary">publicaciones</span>
            </span>
          </div>
          <div className="col-6 col-md-auto d-flex justify-content-md-end">
            <span className="admin-metric-pill">
              <i className="fas fa-layer-group" aria-hidden="true" />
              {cantidadGrupoPlanes} <span className="fw-normal text-body-secondary">grupos</span>
            </span>
          </div>
          <div className="col-6 col-md-auto d-flex align-items-center justify-content-md-end">
            <span className="admin-metric-pill">
              {formatoDecimal(comision)}
              <i className="fas fa-percent" aria-hidden="true" />
            </span>
          </div>
          <div className="col-6 col-md-auto d-flex justify-content-end align-items-center">
            <div className="custom-control form-switch admin-estado-switch" onClick={(e) => e.stopPropagation()}>
              <input
                type="checkbox"
                className="form-check-input"
                checked={isActivo}
                onChange={this.handleSwitchChange}
                aria-label={isActivo ? 'Tipo vigente' : 'Tipo deshabilitado'}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
